import React from 'react';
import { Zap, Mail, Globe, Folder } from 'lucide-react';
export function Footer() {
  return <footer className="bg-footerbg pt-16 pb-8 border-t border-white/10 relative" data-id="element-349">
      {/* Footer Folder Tab */}
      <div className="absolute -top-4 left-6 md:left-10 z-20" data-id="element-350">
        <div className="bg-footerbg border border-white/10 rounded-t-lg px-3 py-1 flex items-center gap-1.5 transform -rotate-1" data-id="element-351">
          <Folder className="w-3 h-3 text-textsecondary" data-id="element-352" />
          <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-textsecondary" data-id="element-353">
            Pie de Página
          </span>
        </div>
      </div>

      <div className="container mx-auto px-4" data-id="element-354">
        <div className="grid md:grid-cols-2 gap-12 mb-12 relative" data-id="element-355">
          {/* Faux Sello */}
          <div className="absolute top-0 right-10 md:right-1/2 md:translate-x-1/2 opacity-20 pointer-events-none select-none" data-id="element-356">
            <div className="w-24 h-24 rounded-full border-4 border-double border-electric flex items-center justify-center transform rotate-12" data-id="element-357">
              <div className="text-center" data-id="element-358">
                <span className="block text-electric font-extrabold text-xl tracking-tighter" data-id="element-359">
                  BD™
                </span>
                <span className="block text-electric text-[8px] font-mono uppercase tracking-widest border-t border-electric mt-1 pt-1" data-id="element-360">
                  Oficial
                </span>
              </div>
            </div>
          </div>

          <div data-id="element-361">
            <div className="flex items-center gap-2 mb-6" data-id="element-362">
              <Zap className="w-6 h-6 text-electric fill-electric" data-id="element-363" />
              <span className="font-bold text-xl tracking-tight" data-id="element-364">
                BIBLIOTECAS DIGITALES™
              </span>
            </div>
            <p className="text-textsecondary max-w-md mb-6" data-id="element-365">
              El sistema N°1 para personas que buscan trabajo y quieren
              conseguir entrevistas reales en Argentina usando el método
              Anti-ATS.
              <br data-id="element-366" />
              <br data-id="element-367" />
              Porque conseguir trabajo no debería depender de mandar CVs al
              vacío esperando que alguien te llame por suerte.
            </p>
          </div>

          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-368">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors mb-4" data-id="element-369">
              <Mail className="w-5 h-5" data-id="element-370" /> soportebibliotecasdigitales@gmail.com
            </a>
            <a href="#" className="flex items-center gap-2 text-textsecondary hover:text-electric transition-colors" data-id="element-371">
              <Globe className="w-5 h-5" data-id="element-372" /> www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        <div className="border-t border-dashed border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-textsecondary/60" data-id="element-373">
          <p data-id="element-374">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}